import { render, staticRenderFns } from "./gallery-image-holder.vue?vue&type=template&id=41932f72&scoped=true&"
import script from "./gallery-image-holder.vue?vue&type=script&lang=js&"
export * from "./gallery-image-holder.vue?vue&type=script&lang=js&"
import style0 from "./gallery-image-holder.vue?vue&type=style&index=0&id=41932f72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41932f72",
  null
  
)

export default component.exports